import { t } from "@lingui/macro";
import * as React from "react";
import { Circle, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CoinsIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Coins`} {...props}>
    <Circle cx={8.5} cy={7.5} r={5.5} fill="currentColor" />
    <Path
      stroke="#F5F5F5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 6h1v3"
    />
    <Path
      fill="currentColor"
      d="M2.05 8.298A6.5 6.5 0 0 0 7.7 13.949 4 4 0 0 1 2.05 8.298Z"
    />
  </Icon>
);
